





































































































import Vue, {PropOptions} from 'vue';

export interface IFrame {
  error: boolean;
  show: boolean;
  disabled: boolean;
  detail: boolean;
  cover: boolean;
  edit: boolean;
  options: boolean;
  sample: boolean;
  icontooltip: boolean;
  nopulldown: boolean;
  noicons: boolean;
}

export class CFrame implements IFrame {
  public error = false;
  public show = true;
  public disabled = false;
  public detail = false;
  public cover = false;
  public edit = false;
  public options = false;
  public sample = false;
  public icontooltip = true;
  public nopulldown = false;
  public noicons = false;
}

export interface IFrameEdit {
  title: string;
  comment: string;
}


export default Vue.extend({
  name: 'GadgetFrame',
  props: {
    title: String,
    csvtitle: String,
    comment: String,
    frameData: Object as PropOptions<IFrame>,
    options: Object,
    optionItems: Array,
    dataType: String,
  },
  data() {
    return {
      titleEdit: '',
      type: '',
      materials: {},
      memoBack: false,
      memoScroll: false,
      memoClick: false,
      commentEditFlag: false,
      commentEdit: '',
      optionsModal: false,
      csvframe: false,
    };
  },
  computed: {
    EDIT() {
      // return this.edit ? '' : 'no_edit';
      return false;
    },
  },
  mounted() {
    this.$data.titleEdit = this.$props.title;
    if (this.$props.comment) {
      this.$data.commentEdit = this.$props.comment.replace(/<br>/gi, '\n');
    }
  },
  methods: {
    returnSetting(key: string): any {
      return (this as any).frameData[key] ? (this as any).frameData[key] : false;
    },
    onClickDetail() {
      if (!this.frameData.cover) {
        this.$emit('detail');
      }
    },
    onClickTrash() {
      if (!this.frameData.cover) {
        this.$emit('trash');
      }
    },
    onClickAddEvent() {
      this.$emit('add');
    },
    onClickQuestionEdit() {
      this.commentEditFlag = !this.commentEditFlag;
    },
    onMemoback(flag: boolean) {
      const result = flag;
      /*
      if (this.edit) {
        result = false;
      }
      */
      if (!this.memoScroll || !this.memoClick) {
        this.memoBack = result;
        const memodom = this.$refs.memodom as Element;
        if (memodom.scrollHeight > memodom.clientHeight) {
          // スクロールバーが出たら「メモを見る」表示
          this.memoScroll = true;
        }
      }
    },
    onClickOptions() {
      this.optionsModal = !this.optionsModal;
    },
  },
  watch: {
    type() {
      // console.log('type chnage');
    },
    titleEdit() {
      this.$emit('frameDataEdit', {title: this.titleEdit, comment: this.commentEdit} as IFrameEdit);
    },
    commentEdit() {
      this.$emit('frameDataEdit', {title: this.titleEdit, comment: this.commentEdit} as IFrameEdit);
    },
    options() {
      this.optionsModal = false;
    },
    // item() {
    //   this.type = this.item.gadgetData.type;
    //   this.materials = this.item.gadgetData.materials;
    // },
  },
});

